<template>
  <div>
    <v-layout row wrap>
      <v-flex d-flex md12>
        <Toolbar>
          <v-flex sm4>
            <span class="mr-4 body-2">String Inverter </span>
            <span class="Subtitle 2">
              [ {{ selectedBlockId ? selectedBlockId.text : '' }} ]
            </span>
            <span class="Subtitle 2">
              {{ selectedInverterListName }}
            </span>
          </v-flex>
          <v-flex sm4 text-sm-center>
            <Toggle :modelValue="scbLiveAvg" @toggleValueChange="toggleLiveAvgHandler" :theme="theme" >
              <v-btn v-if="isLive" flat value="live">{{ $t('Live') }}</v-btn>
              <v-btn flat value="avg">{{ $t('Average') }}</v-btn>
            </Toggle>
          </v-flex>
          <v-flex sm4 text-sm-right>
            <div class="body-1">
              {{ show_date }}
            </div>
          </v-flex>
        </Toolbar>
      </v-flex>
      <v-flex d-flex md7>
        <MapLegend v-for="leg in legend" :key="leg.name" :text="$t(leg.name)" :shape="leg.attr" />
      </v-flex>
    </v-layout>
    <Card>
      <Card class="pa-1 tablediv">
        <v-layout row wrap v-for="item in sortedData" :key="item[0].id"
          class="card-separation">
          <v-flex md4 :class="`--${simpleString(item[0].id)} scbBox`">
            <div class="checkbox">
              <v-checkbox v-model="scbCheckbox[`${item[0].id}`]" :label="item[0].name"
                @change="selectScbHandler(item[0].id)">
              </v-checkbox>
              <div class="tooltip" v-if='item[0].ref_id'>
                ( {{ $t('Ch Ref Id') }}: {{ item[0].ref_id }} )
                <span class="tooltiptext">{{ $t('Channel Ref. Id for Underperforming String') }}</span>
              </div>
            </div>
            <v-layout row wrap pa-1 ma-1>
              <CardText v-for="card in cardData" :key="card.value">
                <template v-slot:text v-if="(!card.optional || (item[0][card.value] && item[0][card.value] >= 0) || (card.optional && item[0][card.value] != null))">
                  {{ card.name }}:
                </template>
                <template v-slot:value v-if="(!card.optional || (item[0][card.value] && item[0][card.value] >= 0) || (card.optional && item[0][card.value] != null))">
                  <span :class="card.method(item[0][card.value]) == null || card.method(item[0][card.value]) == 'No Data' ? 'error--text' : 'number--text'">
                    {{ card.method(item[0][card.value]) }}
                  </span>
                </template>
              </CardText>
              <v-spacer />
            </v-layout>
          </v-flex>
          <v-flex md8 class="scb-channel-data">
            <v-checkbox class="scb_checkbox" :label="$t('Select All Channels')"
              v-model='channelCheckbox[item[0].id]' @change='selectChannelHandler(item[0])'>
            </v-checkbox>
            <CardCheckBox :data="item[0].channel" :id="item[0].id" :selectAll="channelCheckbox[item[0].id]" :clearAll="clearAllChecked" :disable="disableChannelSelection" :condition="cardCondition" :onClick="onChannelClick" />
          </v-flex>
          <v-flex md12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </Card>
      <v-divider></v-divider>
      <div class="button-align">
        <v-btn :class="buttonColor" @click="showGraph()">{{ $t('Show Graph') }}</v-btn>
        <v-btn :class="buttonColor" @click="clearAll()">{{ $t('Clear All') }}</v-btn>
      </div>
    </Card>
    <v-divider></v-divider>
    <GlobalGraph class="graph" v-if="graphActive" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme" :loading="loading" />
  </div>
</template>

<script>
const momentTz = require('moment-timezone');
import moment from 'moment'
import _ from 'lodash'
import { mixin, mapGettersMixin, miscellaneous, filterMixin } from '@/util/mixin/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import CommonService from '../services/Common'
import ScbService from '../services/Scbs'
import GlobalGraph from '@/components/common/GlobalGraph'
import MapLegend from '@/components/common/MapLegend'
import CardText from '@/components/AdvancedScb/CardText'

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous, filterMixin],
  components: {
    MapLegend,
    CardText,
    GlobalGraph
  },

  data() {
    return {
      activeChannels: {},
      channelCheckbox: {},
      scbCheckbox: {},
      scbData: {},
      clearAllChecked: false,
      legend: [
        {
          name: 'Known Issue',
          attr: {
            name: 'square',
            color: '#ECB208'
          }
        },
        {
          name: 'String Underperforming',
          attr: {
            name: 'square',
            color: '#FF5252'
          }
        },
        {
          name: 'Comm Error',
          attr: {
            name: 'square',
            color: '#F69946'
          }
        },
        {
          name: 'NC',
          attr: {
            name: 'square',
            color: '#455A64'
          }
        },
        {
          name: 'Selected',
          attr: {
            name: 'square',
            color: '#818fff'
          }
        }
      ],
      enableWatch: false,
      loading: false,
      graphActive: false,
      scbLiveAvg: 'live',
      series: [],
      xAxis: [],
      yAxis: [
        {
          name: 'Current (A)',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        }
      ],
      disableChannelSelection: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantInfo', 'getGeneralState', 'isUpdateFilterDb']),
    sortedData() {
      // sorting using device ID using lodash
      const keysList = Object.keys(this.scbData)
      if (!_.isEmpty(this.scbData)) {
        keysList.sort((a, b) => {
          const aArr = a.split('-')
          const bArr = b.split('-')
          const baseA = aArr.slice(0, 3)
          const baseB = bArr.slice(0, 3)
          if (_.isEqual(baseA, baseB)) {
            if (+aArr[aArr.length - 1] < +bArr[bArr.length - 1]) return -1
            if (+aArr[aArr.length - 1] > +bArr[bArr.length - 1]) return 1
          } else {
            if (+baseA[baseA.length - 1] < +baseB[baseB.length - 1]) return -1
            if (+baseA[baseA.length - 1] > +baseB[baseB.length - 1]) return 1
          }
          return 0
        })
        return keysList.map(el => this.scbData[el])
      } else {
        return {}
      }
    },
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    selectedBlockId() {
      return this.activeFilter.blockList
    },
    selectedInverters() {
      return this.activeFilter.inverterList ? this.activeFilter.inverterList : []
    },
    selectedInverterListName() {
      if (this.selectedInverters.length > 0) {
        return this.selectedInverters.map((el) => {
          return el.text
        })
      } else {
        return []
      }
    },
    isUpdateData() {
      return `${this.selectedInverters.map(el => el.modifiedId).join()} ${this.isUpdateFilterDb}`
    },
    full_date() {
      return (
        this.activeFilter &&
        this.activeFilter.Date &&
        this.activeFilter.Date.from
      )
    },
    // TODO: Remove this when the time of refactoring API
    show_date() {
      return moment(this.full_date).format('YYYY/M/D')
    },
    isLive() {
      return this.activeFilter &&
        this.activeFilter.Date &&
        this.activeFilter.Date.from
        ? momentTz().tz(this.getActivePlantInfo('timezone')).isSame(this.full_date, 'day')
        : true
    },
    cardData() {
      return [
        {
          name: `${this.$t('Total Current')} (A)`,
          value: 'total_string_current',
          optional: false,
          method: (item) => (item ? parseFloat(item).toFixed(2) : 0)
        },
        {
          name: `${this.$t('Voltage')} (V)`,
          value: 'voltage',
          optional: false,
          method: (item) => (item ? parseFloat(item).toFixed(2) : 0)
        },
        {
          name: `${this.$t('Temp')} (°C)`,
          value: 'temperature',
          optional: false,
          method: (item) => (item ? parseFloat(item).toFixed(2) : 0)
        },
        {
          name: `${this.$t('DC Power')} (kW)`,
          value: 'dc_power',
          optional: false,
          method: (item) => (item ? parseFloat(item).toFixed(2) : 0)
        },
        {
          name: this.$t('Breaker Status'),
          value: 'status1',
          optional: true,
          method: (item) => (item == 1 ? this.$t('ON') : this.$t('OFF'))
        },
        {
          name: this.$t('SPD Status'),
          value: 'status2',
          optional: true,
          method: (item) => (item == 1 ? this.$t('Intact') : this.$t('Blown'))
        }
      ]
    },
    buttonColor() {
      return this.theme == 'dark' ? 'info' : 'grey'
    }
  },
  async created() {
    await this.initialConfigList()
    await this.setIntervalWithoutDelay(this.callAllApi)
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT',
      'SET_PROGRESS_BAR'
    ]),
    ...mapActions(['fetchBlockList', 'fetchIdList']),

    cardCondition(ch, isActive) {
      const currentTime = momentTz().tz(this.getActivePlantInfo('timezone')).format('HH')
      let active = !!isActive
      const isRedBlink =
        parseFloat(ch.value) === 0.0 &&
        this.scbLiveAvg === 'live' &&
        (ch.status === 'no_issue' || ch.status === 'string_underperforming')
      const isWithinGenerationTime = currentTime > 8 && currentTime < 18

      if (isRedBlink && isWithinGenerationTime && active) {
        return 'ch-value_selected'
      }

      if (
        isRedBlink &&
        isWithinGenerationTime &&
        !active &&
        ch.status !== 'known_issue'
      ) {
        return 'ch-value'
      }

      if (isRedBlink && isWithinGenerationTime && !active) {
        return 'default'
      }

      if (!(isRedBlink && isWithinGenerationTime) && active) {
        return 'default-select'
      }

      if (!(isRedBlink && isWithinGenerationTime) && !active) {
        return 'default'
      }
    },
    onChannelClick(ch, isActive, id) {
      const identifier = `${id}-${ch.id}`
      if (ch.status !== 'not_connected') {
        let state = !isActive[identifier]
        this.$set(isActive, identifier, state)

        this.$set(this.activeChannels, identifier, state)
      } else {
        let payload = {
          icon: 'error',
          header: 'Important !',
          message: 'Not-Connected channel cannot be selected'
        }
        this.SET_SNACKBAR_CONTENT(payload)
        this.SET_SHOW_SNACKBAR(true)
      }
    },
    async callAllApi() {
      this.enableWatch = false
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      await this.getScbTableData(this.selectedBlockId, this.selectedInverters)
      if (this.graphActive) {
        await this.showGraph()
      }
    },
    async initialConfigList() {
      let blockListRes = await this.fetchBlockList([
        this.getSelectedPlantId,
        'scb',
        1,
        null
      ])
      const res = await CommonService.getIdList(
        this.getSelectedPlantId,
        'SCB',
        2,
        blockListRes.data.message[0].id
      )
      let roomList = res.data.message
      let roomId = []
      roomList.forEach((el) => {
        roomId.push(el.modifiedId)
      })
      let invListRes = await this.fetchIdList([
        this.getSelectedPlantId,
        'SCB',
        3,
        roomId.join(',')
      ])

      this.setDynamicFilterConfig([
        {
          from: momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD'),
          to: momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
        },
        blockListRes.data.message[0],
        [invListRes.data.message[0]]
      ])
    },
    async getScbTableData(selectedBlockId, selectedInverters) {
      let modifiedId = []
      selectedInverters.forEach((el) => {
        modifiedId.push(el.modifiedId)
      })

      try {
        this.SET_PROGRESS_BAR(true)
        const param = {
          plantId: this.getSelectedPlantId,
          index: this.scbLiveAvg,
          blockId: selectedBlockId['id'],
          modifiedId: modifiedId,
          date: momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD'),
          params: [
            'voltage',
            'temperature',
            'total_string_current',
            'status1',
            'status2',
            'dc_power'
          ]
        }
        const response = await ScbService.fetchScbTableData(param)
        this.scbData = response.data
        this.enableWatch = true
        this.SET_PROGRESS_BAR(false)
        Object.entries(this.scbData).forEach(([key, value]) => {
          this.scbCheckbox[key] = false
          this.$set(this.channelCheckbox, key, false)

          let channels = value[0].channel
          channels.forEach((el) => {
            if (el.status !== 'not_connected') {
              this.activeChannels[`${key}-${el.id}`] = false
            }
          })
        })
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
    async getScbGraphData(modifiedId) {
      try {
        this.SET_PROGRESS_BAR(true)
        const isScb = Object.keys(this.scbCheckbox).filter(
          (el) => !!this.scbCheckbox[el]
        )
        const selectedDate = moment(this.activeFilter['Date'].from).format(
          'YYYY-MM-DD'
        )

        const param = {
          plantId: this.getSelectedPlantId,
          modifiedId: modifiedId,
          date: selectedDate,
          isScb: isScb
        }
        const response = await ScbService.fetchScbGraphData(param)

        this.series.length = 0
        this.SET_PROGRESS_BAR(false)
        Object.keys(response.data.finalData).forEach((id) => {
          this.series.push({
            name: id,
            type: 'line',
            data: response.data.finalData[id]
          })
        })
        this.xAxis = response.data.axis
        this.graphActive = true
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
    async getInverterList(selectedBlockId) {
      const res = await CommonService.getIdList(
        this.getSelectedPlantId,
        'SCB',
        2,
        selectedBlockId
      )
      let roomList = res.data.message
      let roomId = []
      roomList.forEach((el) => {
        roomId.push(el.modifiedId)
      })
      this.fetchIdList([this.getSelectedPlantId, 'SCB', 3, roomId.join(',')])
    },
    selectScbHandler(scbId) {
      // Disable channel selection if scb checkbox is selected
      let elementClassName = this.simpleString(scbId)
      let ele = document.querySelector(`.--${elementClassName}`)
      if (this.scbCheckbox[scbId]) {
        ele.classList.add('scb-selected')
      } else {
        ele.classList.remove('scb-selected')
      }
      this.disableChannelSelection = Object.values(this.scbCheckbox).some(
        (el) => el
      )

      // selecting channels if scb is selected
      Object.keys(this.activeChannels).forEach((el) => {
        let id = el.slice(0, 8)
        if (id[7] === '-') {
          id = id.slice(0, 7)
        }
        if (id === scbId) {
          this.$set(this.activeChannels, el, this.scbCheckbox[scbId])
        }
      })
    },
    selectChannelHandler(val) {
      if (this.channelCheckbox[val.id]) {
        val.channel.forEach((el) => {
          if (el.status !== 'not_connected') {
            let id = `${val.id}-${el.id}`
            this.activeChannels[id] = true
          }
        })
      }
    },
    async showGraph() {
      let selectedChannels = Object.keys(this.activeChannels).filter((el) => {
        if (this.activeChannels[el]) {
          return el
        }
      })
      let modifiedId = {}
      if (selectedChannels.length !== 0) {
        selectedChannels.forEach((el) => {
          let id = el.slice(0, 8)
          if (id[7] == '-') {
            id = id.slice(0, 7)
          }
          let chId = el.slice(-2).replace('-', '')
          if (!modifiedId.hasOwnProperty(id)) {
            modifiedId[id] = []
            modifiedId[id].push(chId)
          } else {
            modifiedId[id].push(chId)
          }
        })
        await this.getScbGraphData(modifiedId)
        const el = document.querySelector('.graph')
        if (el) {
          el.scrollIntoView()
        }
      } else {
        let payload = {
          icon: 'error',
          header: 'An error has occured',
          message:
            'Please select atleast one SCB or Channel in order to plot graph'
        }
        this.SET_SNACKBAR_CONTENT(payload)
        this.SET_SHOW_SNACKBAR(true)
      }
    },
    clearAll() {
      Object.keys(this.activeChannels).forEach((el) => {
        this.activeChannels[el] = false
      })
      this.channelCheckbox = {}
      this.scbCheckbox = {}

      // Removing the border from scb checkbox container if its there
      this.disableChannelSelection = false
      let eleArr = document.querySelectorAll(`.scbBox`)
      eleArr.forEach((el) => {
        if (el.classList.contains('scb-selected')) {
          el.classList.remove('scb-selected')
        }
      })
      this.clearAllChecked = !this.clearAllChecked
      this.graphActive = false
    },
    toggleLiveAvgHandler(val) {
      this.scbLiveAvg = val
      this.setIntervalWithoutDelay(this.callAllApi)
    }
  },
  watch: {
    async getSelectedPlantId() {
      this.activeChannels = {}
      this.channelCheckbox = {}
      this.scbCheckbox = {}
      this.graphActive = false
      await this.initialConfigList()
      await this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    },
    'selectedBlockId.id'(val) {
      if (this.enableWatch) {
        this.getInverterList(val)
      }
    },
    isUpdateData() {
      if (this.enableWatch && this.isUpdateFilterDb) {
        if (this.selectedInverters.length === 0) {
          let payload = {
            icon: 'error',
            message: 'Minimun one device will be selected'
          }
          this.SET_SNACKBAR_CONTENT(payload)
          this.SET_SHOW_SNACKBAR(true)
        } else {
          this.setIntervalWithoutDelay(this.callAllApi)
        }
      }
    },
    full_date() {
      if (this.enableWatch) {
        const currentDate = momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
        let date = moment(this.full_date).format('YYYY-MM-DD')

        if (moment(date).isBefore(currentDate)) {
          this.scbLiveAvg = 'avg'
        } else {
          this.scbLiveAvg = 'live'
        }
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
.scb-selected {
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.graph {
  width: 100%;
  height: 400px;
}

.scb_data {
  /* color: white; */
  font-size: 16px;
}

.theme--light .scb_data {
  /* color: black; */
  font-size: 16px;
}

#card-box {
  /* background-color: #1b243a; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.theme--light #card-box {
  /* background-color: #E0E0E0; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.button-align {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.chisActive h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.select {
  border: 1px solid;
  width: 245px;
}

.theme--light .scb_header {
  /* color: #3347df; */
  font-weight: bold;
  font-size: 14px;
}

.scb_header {
  /* color: #818fff; */
  font-weight: bold;
  font-size: 14px;
}

.checkbox {
  padding-left: 15px;
  display: inline-flex;
}

.theme--dark .tooltip {
  margin-top: 9.5px;
  margin-left: 3px;
  /* color: #909cff; */
  font-size: 12px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}

.theme--light .tooltip {
  margin-top: 9.5px;
  margin-left: 3px;
  /* color: #3347df; */
  font-size: 12px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}

.theme--dark .tooltip .tooltiptext {
  visibility: hidden;
  width: 255px;
  /* background-color: #F5F5F5; */
  /* color: black; */
  text-align: center;
  border-radius: 6px;
  padding: 2px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}

.theme--light .tooltip .tooltiptext {
  visibility: hidden;
  width: 255px;
  /* background-color: #e3e3e3; */
  color: black;
  text-align: center;
  border-radius: 6px;
  padding: 2px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.select_inv {
  /* color: #818fff !important; */
  width: 200px;
}

.card-separation {
  margin-bottom: 15px !important;
  /* /* border-radius: 8px; */
}

.v-message {
  min-height: 0px;
  min-width: 0px;
}

.container {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 4px;
}

.container.grid-list-lg *:not(:only-child) .layout:first-child {
  margin-top: 0px;
}

.container.grid-list-lg .layout:not(:only-child) {
  margin: auto 0px;
}

.theme--light.v-label {
  color: black;
}

@media only screen and (min-width: 1904px) and (max-width: 2544px) {
  .tablediv {
    max-height: 56.5vh;
    min-height: 56.5vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1584px) and (max-width: 1904px) {
  .tablediv {
    max-height: 430px;
    min-height: 430px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1394px) and (max-width: 1585px) {
  .tablediv {
    max-height: 340px;
    min-height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1394px) {
  .tablediv {
    max-height: 270px;
    min-height: 270px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

.scb_checkbox {
  margin-left: 12px;
  margin-top: 0px;
  margin-bottom: 4px;
}
</style>
<style>
#select
  .v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  min-height: 20px;
  width: 100%;
}

#select .v-input__control {
  display: contents;
}

#date .el-input__inner {
  border: 1px solid !important;
  /* background-color: #1B243A */
}

.theme--light #date .el-input__inner {
  border: 1px solid !important;
  /* background-color: #E0E0E0 !important; */
}

.container.grid-list-lg .layout .flex {
  padding: 4px;
}

.v-messages {
  min-height: 0px;
}

.v-select__selection--comma {
  margin: 0;
}

.v-text-field.v-text-field--enclosed {
  margin: 2px;
}
</style>
